angular.module('labApp').factory('AggregatedResultsFactory', function($resource) {
    return $resource('api/v1.0/lab/reporting-results/:assessment_slug/');
});
